<template>
  <div>
    <h3>All Callers Log</h3>
    <div class="row">
      <div class="col-12">
        <div v-for="(day_data,day_index) in get_call_log.days" v-bind:key="day_data.day">

          <h5>{{day_data.day}} - Total: {{day_data.total_count}} Calls made: {{day_data.good_count}} Not called: {{day_data.bad_count}}</h5>

          <table class="table table-striped table-bordered table-hover table-condensed align_left">
            <thead>
            <tr>
              <th>Date</th>
              <th>Dispensary / Shop</th>
              <th>Activity</th>
              <th>Caller</th>
              <th>Notes</th>
            </tr>
            </thead>
            <tbody class="align_left">
            <tr v-for="(activity,list_index) in day_data.data" v-bind:key="list_index">
              <td>
                {{activity.create_date}}
              </td>
              <td>

                <template v-if="activity.shop_number === 0">
                  {{activity.shop_name}} <br> ({{activity.customer_id}})
                </template>
                <template v-else>
                  {{activity.shop_name}} <br> ({{activity.customer_id}}-{{activity.shop_number}})
                </template>



              </td>


              <td  @mouseover="mouseOver(list_index,day_index)" @mouseleave="mouseLeave()">
<!--                <p style="text-align: left;" v-if="list_index === list_hover_index && day_index === list_day_index">{{hover_text}}</p>-->
                <div>{{activity.log_text}}</div>
              </td>


              <td>
                {{activity.admin_name}}
              </td>
              <td width="50%">
                {{activity.notes}}
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      hover_text: '',
      list_hover_index: -1,
      list_day_index: -1,
    }
  },
  computed: {
    ...mapGetters({
      get_call_log: 'admin/get_call_log',
      get_call_log_loading: 'admin/get_call_log_loading',
    }),
  },
  mounted() {
    this.get_call_log_array(); // for reloads dev
  },
  methods: {
    mouseOver: function(list_index,day_index) {
      this.hover_text = this.get_call_log.days[day_index].data[list_index].notes;
      this.list_day_index = day_index;
      this.list_hover_index = list_index;
    },
    mouseLeave: function() {
      this.hover_text = '';
      this.list_hover_index = -1;
      this.list_day_index = -1;
    },
    get_call_log_array () {
      this.$store.dispatch('admin/getCallLog', {'test_param':0});
    },
  }
}
</script>

<style scoped>

.align_left {
  text-align: left;
}

</style>
